import { DeleteButton, EditButton } from "@/components/IconButton/variants";

export default function Actions({ row, handleOnClickDelete }) {
  return (
    <div className="justify-center flex gap-x-1 ">
      <EditButton
        onClick={() => {
          console.log("EDIT BUTTON CLICKED");
        }}
        tooltipText="Edit User Data"
      />
      <DeleteButton
        onClick={() => {
          handleOnClickDelete(row.original);
        }}
      />
    </div>
  );
}
